<div class="event-apps tw-px-2 tw-w-full tw-font-inter">
  @if (isLoading() && eventApps().length === 0) {
    <div class="tw-w-full lg:tw-max-w-[850px] xl:tw-max-w-[1200px] tw-mx-auto tw-py-6" role="status" aria-label="Loading event apps">
      <div class="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
        @for (_skeleton of [1, 2, 3]; track $index) {
          <div class="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '100%', height: '140px', 'border-radius': '0', backgroundColor: '#e5e7eb', marginBottom: '0' }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <div class="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3">
              <ngx-skeleton-loader
                count="1"
                [theme]="{ width: '70%', height: '16px', 'border-radius': '4px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
                animation="pulse"
              ></ngx-skeleton-loader>
              <ngx-skeleton-loader
                count="1"
                [theme]="{ width: '100%', height: '36px', 'border-radius': '4px', backgroundColor: '#e5e7eb', marginBottom: '0' }"
                animation="pulse"
              ></ngx-skeleton-loader>
            </div>
          </div>
        }
      </div>
    </div>
  } @else if (eventApps().length === 0) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-gap-8 tw-py-6 tw-px-4 lg:tw-pb-12 lg:tw-pt-40">
      <img src="assets/images/v2/noApps.svg" alt="No apps" class="tw-w-full md:tw-w-[400px]" />
      <h1 class="tw-text-lg lg:tw-text-xl tw-text-gray-900 tw-text-center tw-mb-2 tw-font-inter">You didn’t add any apps yet.</h1>
      <button
        type="button"
        class="tw-font-inter tw-bg-blue-600 tw-text-white tw-text-sm lg:tw-text-base tw-font-medium tw-rounded-lg tw-px-5 tw-py-2.5 lg:tw-py-[14px] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-12 tw-w-[174px]"
        (click)="openAddAppModal()"
      >
        <i class="fas fa-plus tw-text-white tw-text-base"></i>Add first app
      </button>
    </div>
  } @else {
    <div class="tw-flex tw-w-full lg:tw-max-w-[850px] xl:tw-max-w-[1200px] tw-mx-auto tw-flex-col tw-gap-5 tw-py-6">
      <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
        <h2 class="tw-font-inter tw-text-[28px] tw-font-bold tw-text-gray-700">Event apps ({{ eventApps().length }})</h2>
        <button
          type="button"
          class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-font-inter tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700"
          (click)="openAddAppModal()"
        >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.2222 6.22222H7.77778V0.777778C7.77778 0.571498 7.69583 0.373667 7.54997 0.227806C7.40411 0.0819442 7.20628 0 7 0C6.79372 0 6.59589 0.0819442 6.45003 0.227806C6.30417 0.373667 6.22222 0.571498 6.22222 0.777778V6.22222H0.777778C0.571498 6.22222 0.373667 6.30417 0.227806 6.45003C0.0819442 6.59589 0 6.79372 0 7C0 7.20628 0.0819442 7.40411 0.227806 7.54997C0.373667 7.69583 0.571498 7.77778 0.777778 7.77778H6.22222V13.2222C6.22222 13.4285 6.30417 13.6263 6.45003 13.7722C6.59589 13.9181 6.79372 14 7 14C7.20628 14 7.40411 13.9181 7.54997 13.7722C7.69583 13.6263 7.77778 13.4285 7.77778 13.2222V7.77778H13.2222C13.4285 7.77778 13.6263 7.69583 13.7722 7.54997C13.9181 7.40411 14 7.20628 14 7C14 6.79372 13.9181 6.59589 13.7722 6.45003C13.6263 6.30417 13.4285 6.22222 13.2222 6.22222Z" fill="white"/>
        </svg>          
          Add event app
        </button>
      </div>
      <div class="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 lg:tw-grid-cols-3">
        @for (app of eventApps(); track app.id) {
          <app-event-app-card
            [eventApp]="app"
            [handshakeSettingsLoading]="handshakeLoadingAppId() === app.id"
            [snoballSettingsLoading]="snoballLoadingAppId() === app.id"
            [snoballActivateLoading]="snoballActivatingAppId() === app.id"
            (removed)="onAppRemoved($event)"
            (handshakeSettings)="onHandshakeSettings($event)"
            (snoballSettings)="openSnoballSetup($event)"
            (snoballActivate)="onSnoballActivate($event)"
            (updated)="onAppUpdated(app, $event)"
          />
        }
      </div>
    </div>
  }

  <app-event-apps-modal
    [eventId]="eventId"
    [eventName]="eventName"
    [eventSlug]="eventSlug"
    [existingApps]="eventApps()"
    (appCreated)="onAppCreated($event)"
    (configureRequested)="openSnoballSetup($event)"
  />

  @if (isHandshakeSetupModalOpen()) {
    <app-handshake-setup-modal
      [eventApp]="handshakeSetupApp()"
      [eventId]="eventId"
      [initialPersonas]="handshakePersonas()"
      (onCloseModal)="closeHandshakeSetupModal()"
    />
  }

  @if (isSnoballSetupModalOpen()) {
    <app-snoball-setup-modal
      [eventApp]="snoballSetupApp()"
      [eventId]="eventId"
      [personas]="snoballPersonas()"
      (onCloseModal)="closeSnoballSetupModal()"
    />
  }

  @if (isDeleteModalOpen()) {
    <delete-modal
      [id]="deleteModalId"
      [message]="deleteConfirmMessage()"
      (onDelete)="onDeleteConfirmed()"
      (onCancel)="closeDeleteModal()"
    ></delete-modal>
  }
</div>
